// assets
import { ChromeOutlined, LogoutOutlined } from '@ant-design/icons';

// icons
const icons = {
  ChromeOutlined,
  LogoutOutlined
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const support = {
  id: 'support',
  title: 'Support',
  type: 'group',
  children: [
    {
      id: 'help',
      title: 'Help',
      type: 'item',
      url: '/help',
      icon: 'HelpIcon'
    },
    {
      id: 'logout',
      title: 'Logout',
      type: 'item',
      url: 'logout',
      icon: 'LogoutMenuIcon'
    }
  ]
};

export default support;
